import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth, homeFor } from "@/context/AuthContext";
import { errMsg } from "@/lib/api";
import AuthLayout from "@/components/AuthLayout";
import { Eye, EyeOff } from "lucide-react";
import { t } from "@/lib/i18n";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const [show, setShow] = useState(false);
  const expired = new URLSearchParams(window.location.search).get("expired") === "1";

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      const u = await login(email, password);
      navigate(homeFor(u));
    } catch (err) { setError(errMsg(err)); }
    setBusy(false);
  };

  return (
    <AuthLayout title={t("Login")} subtitle={<>{t("New user?")} <Link to="/register" className="text-amber-600 font-bold" data-testid="login-signup-link">{t("Signup")}</Link></>}>
      <form onSubmit={submit} className="space-y-5" data-testid="login-form">
        <div>
          <label className="hf-label">{t("Email")}</label>
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="hf-input" data-testid="login-email-input" />
        </div>
        <div>
          <label className="hf-label">{t("Password")}</label>
          <div className="relative">
            <input type={show ? "text" : "password"} required value={password} onChange={(e) => setPassword(e.target.value)} className="hf-input pr-12" data-testid="login-password-input" />
            <button type="button" onClick={() => setShow(!show)} className="absolute right-4 top-1/2 -translate-y-1/2 text-slate-500" data-testid="toggle-password-visibility" aria-label={t("Show password")}>{show ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />}</button>
          </div>
        </div>
        <div className="flex justify-end -mt-2"><Link to="/forgot-password" className="text-sm text-slate-600 hover:text-amber-600" data-testid="forgot-password-link">{t("forgot password?")}</Link></div>
        {expired && !error && <p className="text-sm text-amber-800 bg-amber-50 border border-amber-200 rounded-xl p-3" data-testid="session-expired-notice">{t("Session expired — please log in again")}</p>}
        {error && <p className="text-sm text-red-600" data-testid="login-error">{error}</p>}
        <button disabled={busy} className="hf-btn-dark w-full h-12 text-base" data-testid="login-submit-btn">{busy ? t("Signing in…") : t("Login")}</button>
      </form>
    </AuthLayout>
  );
}
